import { heroData } from '@/mocks/homeData';

export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[680px] flex items-center bg-background-50 overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/40"></div>

      <div className="relative w-full px-4 md:px-6 pt-[88px] pb-12 md:pb-16">
        <div className="mx-auto max-w-[1280px] flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-xs md:text-sm font-medium mb-5">
              {heroData.tag}
            </span>

            <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight mb-4">
              韩国漫画
              <span className="block text-primary-500 mt-1">高清韩国漫画在线免费阅读平台</span>
            </h1>

            <p className="text-sm md:text-base font-medium text-foreground-600 mb-4">
              {heroData.slogan}
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-[600px] lg:max-w-none mb-6">
              {heroData.description}
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 md:gap-8 mb-7">
              {heroData.stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-xl md:text-2xl font-heading font-bold text-primary-500">
                    {stat.value}
                  </div>
                  <div className="text-xs text-foreground-500 mt-0.5">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors duration-200"
              >
                <i className="ri-fire-line text-lg"></i>
                查看热门排行
              </a>
              <a
                href="#index"
                className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 rounded-full border-2 border-secondary-300 text-foreground-700 font-medium text-sm hover:border-secondary-400 hover:bg-secondary-50 transition-colors duration-200"
              >
                <i className="ri-grid-line text-lg"></i>
                浏览专题合集
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[480px] lg:max-w-[520px]">
            <div className="relative w-full aspect-[4/5] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%20of%20multiple%20diverse%20characters%20in%20dynamic%20poses%2C%20colorful%20manga%20art%2C%20romance%20fantasy%20action%20characters%20together%2C%20vibrant%20warm%20colors%2C%20dramatic%20lighting%2C%20comic%20panel%20style%20composition%2C%20digital%20painting%2C%20Korean%20manhwa%20aesthetic%2C%20clean%20lines%2C%20rich%20details%2C%20cinematic%20feel&width=1040&height=1300&seq=hero-main-visual&orientation=portrait"
                alt="韩国漫画 - 高清韩国漫画在线免费阅读平台主视觉"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}